<template>
  <div class="register">
    <RegisterForm
      :registrationError="registrationError"
    />
    <router-link to="login">
      <span class="smaller">Already have an account? Log In</span>
    </router-link>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import RegisterForm from 'shared/components/RegisterForm.vue';

export default {
  name: 'Register',
  components: {
    RegisterForm,
  },
  computed: {
    ...mapState({
      registrationError: state => state.users.registrationError,
    }),
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.register {
  text-align: center;
  main {
    padding-top: 50px;
    .register-form {
      padding: 0px 40px;
      width: 33%;
      min-width: 450px;
      margin-bottom: 20px;
    }
    .logo {
      margin-bottom: 40px;
      padding: 0px 10px 0px;
      max-width: 100%;
    }
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .submit-button {
      background-color: rgb(23, 198, 140);
      color: white;
      &:disabled {
        background-color: gainsboro !important;
      }
    }
    .title {
      text-align: center;
    }
    .error {
      color: red;
      text-align: center;
    }
  }
  a {
    text-decoration: none;
  }
  .smaller {
    font-size: 16px;
    color: darkgrey;
    font-weight: lighter;
    padding-bottom: 40px;
    &:hover {
      font-weight: 450;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Register.vue